import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from './base.service';
import {Observable} from 'rxjs';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';
import {AppUrl} from '../constants/app-url';

@Injectable({
    providedIn: 'root'
})
export class KeyIngredientService extends BaseService {
    constructor(public http: HttpClient,
                public alertService: AlertService,
                public globalService: GlobalService) {
        super(http, alertService, globalService);
    }

    get(data): Observable<any> {
        return this.getRequest(AppUrl.KEY_INGREDIENT(), data);
    }

    count(): Observable<any> {
        return this.getRequest(AppUrl.KEY_INGREDIENT_COUNT());
    }

    detail(id): Observable<any> {
        return this.getRequest(AppUrl.KEY_INGREDIENT(id));
    }

    create(id,data): Observable<any> {
        return this.postRequest(AppUrl.KEY_INGREDIENT(id), data);
    }

    deleteProductImage(id): Observable<any> {
        return this.deleteRequest(AppUrl.KEY_INGREDIENT(id));
    }
}
